module.exports = __webpack_public_path__ + "static/media/real-estate.89bed22f.png";